import React from "react";
import { Inner } from "./styles";

const DropShadow = ({ children, ...restProps }) => (
  <Inner {...restProps}>{children}</Inner>
);

export default DropShadow;
